import { GridColumn } from 'src/components/GridWrapper';

export const InvalidGlCodeColumns: GridColumn<any>[] = [
  {
    field: 'glCode',
    title: 'GL Code',
    dataType: 'string',
    menu: false,
  },
  {
    field: 'description',
    title: 'Description',
    dataType: 'string',
    menu: false,
  },
  {
    field: 'companyName',
    title: 'Company Name',
    dataType: 'string',
    menu: false,
  },
  {
    field: 'companyId',
    title: 'Company ID',
    dataType: 'string',
    menu: false,
  },
  {
    field: 'propertyNumber',
    title: 'Property Number',
    dataType: 'string',
    menu: false,
  },
];
